<template>
  <div class="work-order-detail">
    <el-row :gutter="20">
      <el-col :span="12">
        <work-order-status-info
          :work-order="wkDetailInfo"
        ></work-order-status-info>
        <work-order-base-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-base-info>
        <work-order-apply-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-apply-info>
        <work-order-user-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-user-info>
        <work-order-more-info
          :work-order="wkDetailInfo"
          label-width="110px"
          @refresh="getMyDealWorkOrderDetail"
        ></work-order-more-info>
      </el-col>
      <el-col :span="12">
        <work-order-card :isShowHeader="false">
          <work-order-tool
            slot="card-body"
            :work-order="wkDetailInfo"
            @refresh="getMyDealWorkOrderDetail"
          ></work-order-tool>
        </work-order-card>
        <el-card style="margin-bottom: 10px">
          <el-tabs v-model="isActive">
            <el-tab-pane
              label="回复"
              name="reply"
              v-if="!isCloseStatus && isCurrAcceptUser"
            >
              <template v-if="!isCloseStatus">
                <work-order-editor
                  ref="workOrderRef"
                  :configAttachmentsExpDate="true"
                ></work-order-editor>
                <div style="text-align: center">
                  <el-button
                    :loading="replayLoading"
                    :disabled="isCloseStatus"
                    @click="dealWorkOrderById(1)"
                    size="small"
                    type="primary"
                  >
                    回复
                  </el-button>
                </div>
              </template>
            </el-tab-pane>
            <el-tab-pane
              label="转接"
              name="transfer"
              v-if="
                (isAcceptStatus && isCurrAcceptUser) ||
                (isProcessingStatus && isCurrAcceptUser)
              "
            >
              <work-order-transfer
                :work-order="wkDetailInfo"
                @change="getMyDealWorkOrderDetail"
              ></work-order-transfer>
            </el-tab-pane>
            <el-tab-pane label="标签" name="tag">
              <work-order-tag-info
                :work-order="wkDetailInfo"
                @change="getMyDealWorkOrderDetail"
              ></work-order-tag-info>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <el-card style="margin-bottom: 10px">
          <work-order-process :work-order="wkDetailInfo"></work-order-process>
        </el-card>
      </el-col>
    </el-row>
    <temp-dialog></temp-dialog>
  </div>
</template>

<script>
import api from "plus/api";
import axios from "axios";

export default {
  name: "work.myAccept.detail",
  components: {},
  data() {
    return {
      isActive: "reply",
      wkDetailInfo: {},
      replayLoading: false,
    };
  },
  computed: {
    wkOrderId() {
      return this.$route.query.wkOrderId;
    },
    id() {
      return this.$route.query.id;
    },
    workOrder() {
      return this.wkDetailInfo;
    },
    //待处理
    isAcceptStatus() {
      return this.workOrder && this.workOrder.status === 0;
    },
    //已处理
    isWaitForFeedStatus() {
      return this.workOrder && this.workOrder.status === 1;
    },
    //已关闭
    isCloseStatus() {
      return this.workOrder && this.workOrder.status === 2;
    },
    //处理中
    isProcessingStatus() {
      return this.workOrder && this.workOrder.status === 4;
    },
    isCurrAcceptUser() {
      return (
        this.wkDetailInfo &&
        this.wkDetailInfo.acceptUsers &&
        this.wkDetailInfo.acceptUsers.length > 0 &&
        this.wkDetailInfo.acceptUsers.some(
          (item) => item.userId === this.$store.state.userInfo.userId,
        )
      );
    },
    userType() {
      const userType = new Map([
        ["work.myAccept.detail", "ACCEPTOR"],
        ["work.mySubmit.detail", "AUTHOR"],
        ["workmange.workQuality.detail", "MANAGER"],
        ["workmange.workOrderList.detail", "MANAGER"],
      ]);
      return userType.get(this.$route.name);
    },
  },
  activated() {
    this.getMyDealWorkOrderDetail();
  },
  deactivated() {
    this.resetData();
    this.isActive = "reply";
  },
  methods: {
    resetData() {
      this.wkDetailInfo = {};
    },
    getMyDealWorkOrderDetail() {
      return api.work
        .getWorkDetail({ id: this.id })
        .then((res) => {
          const data = res.data.data;
          this.wkDetailInfo = data;
          if (this.wkDetailInfo.status === 2) {
            return (this.isActive = "tag");
          }
          if (!this.isCurrAcceptUser) {
            return (this.isActive = "tag");
          }
        })
        .catch((err) => {});
    },
    async dealWorkOrderById(status) {
      this.replayLoading = true;
      try {
        const editorParams = this.$refs.workOrderRef.getData();
        if (!editorParams.remark) {
          return this.$message.warning("请填写反馈信息！");
        }
        const tempPara = {
          ...editorParams,
          workOrderId: this.wkOrderId,
          optUserType: this.userType,
        };
        if (status === 3) {
          try {
            this.$confirm("注意！该工单将会驳回给提问人，请慎重", "驳回工单", {
              confirmButtonText: "确认",
              confirmButtonClass: "confirmBtn",
              cancelButtonText: "取消",
              type: "warning",
            }).then(async () => {
              const dealRes = await api.work.dealWorkOrderById(tempPara);
              if (dealRes.data.success) {
                this.$message.success("操作成功！");
                this.$refs.workOrderRef.clearData();
                await this.getMyDealWorkOrderDetail();
              }
            });
          } catch (err) {}
        } else {
          const dealRes = await api.work.replyWorkOrder(tempPara);
          if (dealRes.data.success) {
            this.$message.success("操作成功！");
            this.$refs.workOrderRef.clearData();
            await this.getMyDealWorkOrderDetail();
          }
        }
      } finally {
        this.replayLoading = false;
      }
    },
    // handleResultClick(status) {
    //   const editorParams = this.$refs.workOrderRef.getData();
    //   if (!editorParams.remark) {
    //     return this.$message.warning("请填写反馈信息！");
    //   }
    //   const params = {
    //     ...editorParams,
    //     workOrderId: this.wkOrderId,
    //   };
    //   if (status) {
    //     this.$confirm(
    //       "通过后，工单将流转给" +
    //         this.wkDetailInfo.finalAcceptUser.userName +
    //         "做最终处理",
    //       "是否确认通过？",
    //       {
    //         confirmButtonText: "确认通过",
    //         cancelButtonText: "再想想",
    //         type: "warning",
    //         center: true,
    //       }
    //     )
    //       .then(() => {
    //         api.work.passRealtionWorkOrder(params).then((res) => {
    //           if (res.data.success) {
    //             this.$message.success("操作成功");
    //             this.$refs.workOrderRef.clearData();
    //             this.getMyDealWorkOrderDetail();
    //           } else {
    //             this.$message.error(res.data.msg);
    //           }
    //         });
    //       })
    //       .catch(() => {});
    //   } else {
    //     this.$confirm(
    //       "确认后，该工单将被直接关闭。",
    //       "是否确认不通过此工单？",
    //       {
    //         confirmButtonText: "不通过",
    //         cancelButtonText: "再想想",
    //         type: "warning",
    //         center: true,
    //       }
    //     )
    //       .then(() => {
    //         api.work.notPassRealtionWorkOrder(params).then((res) => {
    //           if (res.data.success) {
    //             this.$message.success("操作成功");
    //             this.$refs.workOrderRef.clearData();
    //             this.getMyDealWorkOrderDetail();
    //           } else {
    //             this.$message.error(res.data.msg);
    //           }
    //         });
    //       })
    //       .catch(() => {});
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.work-order-detail {
  width: 100%;

  .detail-header {
    width: 100%;
    background: #fff;
  }

  .quill-editor-container {
    padding-bottom: 32px;

    .quill-editor-box {
      position: relative;

      .quill-editor {
        padding: 20px 47px 20px 95px;
        height: 365px;

        /deep/ .ql-container {
          height: calc(100% - 42px);
        }
      }

      .quill-text-limit {
        position: absolute;
        bottom: 30px;
        right: 60px;
        color: #888;
      }
    }

    .quill-editor-options-box {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding-left: 95px;
      padding-right: 47px;
      position: relative;

      /deep/ .upload-file {
        font-size: 14px;

        .el-upload-list {
          padding-left: 78px;
        }

        .upload-img {
          display: flex;
          margin-top: 10px;

          .label {
            display: inline-block;
            width: 100px;
            margin-right: 12px;
            box-sizing: border-box;
            color: #3572e2;
          }
        }

        .upload-text-btn {
          color: #3572e2;
          margin-right: 12px;
        }

        .upload-limit {
          color: #999;
        }
      }
    }
  }

  .record {
    width: 100%;
    margin-top: 30px;

    .record-container {
      padding-left: 16px;
      box-sizing: border-box;
    }
  }
}

.el-button {
  width: 104px;
  height: 36px;
  border-radius: 2px;
  font-size: 14px;
}
</style>
